import React from 'react';

interface AskForSupportButtonProps {
    label: string | null | undefined;
    link: string | null | undefined;
}

const AskForSupportButton: React.FC<AskForSupportButtonProps> = ({ label, link }) => {
    return link ? (
        <div>
            <a href={link}
               target="_bkank"
               rel="noopener noreferrer"
               className="ms-sub-header__menu-container__right-buttons__ask-for-support-button"
            >
                {label}
            </a>
        </div>
    ) :
    (
        <div></div>
    );
};

export default AskForSupportButton;
